import { useEffect, useState } from "react";
import * as Y from "yjs";
import { ySyncPlugin, yCursorPlugin, yUndoPlugin, prosemirrorToYXmlFragment } from "y-prosemirror";
import { useRef } from "react";

import { buildTicketedWebSocketURL } from "../../../api/api";

import { CollabProvider } from "./collab-provider";

const PALETTE = [
  "#2563eb",
  "#16a34a",
  "#db2777",
  "#d97706",
  "#7c3aed",
  "#0891b2",
  "#dc2626",
  "#4f46e5",
];
export function pickColor(id) {
  const n = String(id ?? "")
    .split("")
    .reduce((a, c) => a + c.charCodeAt(0), 0);
  return PALETTE[n % PALETTE.length];
}
// getSeedDoc: () => ProseMirror Node | null   (only used when seedSource==="docx")
export function useCollaboration({
  enabled,
  wsPath,
  seedSource,
  docId,
  user,
  onControl,
  getSeedDoc,
}) {
  const [ready, setReady] = useState(null);
  const onControlRef = useRef(onControl);
  onControlRef.current = onControl;
  useEffect(() => {
    if (!enabled || !wsPath) return undefined;
    let disposed = false;

    const ydoc = new Y.Doc();
    const fragment = ydoc.getXmlFragment("prosemirror");

    // SEEDER ONLY: write the parsed draft into the shared fragment BEFORE the
    // provider connects, so the room initializes with the draft, not empty.
    // if (seedSource === "docx") {
    //   const node = getSeedDoc?.();
    //   if (node && fragment.length === 0) {
    //     prosemirrorToYXmlFragment(node, fragment);
    //   }
    // }
    if (seedSource === "docx") {
      const node = getSeedDoc?.();
      if (node && fragment.length === 0) prosemirrorToYXmlFragment(node, fragment);
    }

    const provider = new CollabProvider(wsPath, ydoc, {
      getUrl: () => buildTicketedWebSocketURL(wsPath),
      onControl: (msg) => onControlRef.current?.(msg),
    });
    provider.awareness.setLocalStateField("user", user);
    const plugins = [ySyncPlugin(fragment), yCursorPlugin(provider.awareness), yUndoPlugin()];
    if (!disposed) setReady({ plugins, provider, ydoc });
    return () => {
      disposed = true;
      provider.destroy();
      ydoc.destroy();
      setReady(null);
    };
    // return () => {
    //   disposed = true;
    //   provider.destroy();
    //   ydoc.destroy();
    //   setReady(null);
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, wsPath, seedSource, docId]);

  return ready;
}
